import React from 'react'
import { ToolTipIcon } from './ToolTipIcon'

interface ToolTipContentProps {
  icon?: string
  content: string
  percentage: string
}

export function ToolTipContent({ content, percentage, icon }: ToolTipContentProps) {
  return (
    <>
      {icon && <ToolTipIcon style={{ gridColumn: 1 }} icon={icon} />}
      <div style={icon ? { gridColumn: 2 } : { gridColumn: 1 }} className="content">
        {content}
      </div>
      <div style={icon ? { gridColumn: 3 } : { gridColumn: 2 }} className="percentage">
        {percentage}
      </div>
    </>
  )
}
